import axios from 'axios'
import { BASE_API_URL } from '../api'

const initEvent = function () {
  return {
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    content: '',
    title: ''
  }
}

const instance = axios.create({
  baseURL: BASE_API_URL
})

const state = {
  calendar: {
    title: '',
    contents: '',
    startDate: null,
    startTime: null,
    hasTime: null,
    dialog: false
  },
  event: initEvent(),
  events: [],
  files: [],
  boards: {
    list: [],
    total: 0
  }
}
const mutations = {
  openCalendarDialog (state, payload) {
    state.calendar.startDate = payload.date
    state.calendar.startTime = payload.time
    state.calendar.hasTime = payload.hasTime
    state.calendar.dialog = true
  },
  closeCalendarDialog (state) {
    state.calendar.dialog = false
  },
  addEvent (state, event) {
    state.events.push(event)
    state.calendar.dialog = false
    state.event = initEvent()
  },
  addFiles (state, file) {
    state.files.push(file)
  }
}

const actions = {
  /**
   * 카테고리, 페이지, 검색 기준에 맞춰 서버로 글 리스트를 요청
   * @param {Object} context state 같은 vuex 관련 변수등을 담고있는 오브젝트
   * @param {Object} payload 카테고리, 페이지, 검색 기준이 들어가있는 오브젝트
   * @returns {undefined} 아무것도 반환하지 않음
   */
  fetchBoardList (context, payload) {
    if (payload.searchType && payload.search !== '') {
      instance.get(`/edu/${payload.type}?page=${payload.page}&search=${payload.search}&type=${payload.searchType}`)
        .then(res => {
          console.log(res.data)
          // context.state.boards.list = res.data.boards
          // context.state.boards.total = res.data.total_length
          context.state.boards.list = res.data
          context.state.boards.total = res.data.length
        }).catch(err => {
          console.error('fetchBoardList', err)
        })
    } else {
      instance.get(`/edu/${payload.type}?page=${payload.page}`)
        .then(res => {
          console.log(res.data)
          // context.state.boards.list = res.data.boards
          // context.state.boards.total = res.data.total_length
          context.state.boards.list = res.data
          context.state.boards.total = res.data.length
        }).catch(err => {
          console.error('fetchBoardList', err)
        })
    }
  },
  fetchEventList (context) {
    instance.get('/edu/event/')
      .then(res => {
        context.state.events = JSON.parse(res.data[0].events)
      }).catch(err => {
        console.error('fetchEventList', err)
      })
  },
  updateEventList (context) {
    const events = JSON.stringify(context.state.events)
    instance.put(`/edu/event/${1}/`, { events })
      .then(res => {
        // console.log(res.data)
      }).catch(err => {
        console.error('updateEventList', err)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
